import React from 'react';
import PropTypes from 'prop-types';

import { ensureCurrencyIsPresent } from './util';
import StripeChargeModalIconRenderWrapper from './StripeChargeModalIconRenderWrapper';

export default function StripeChargeModalPaymentSummaryLineItemV2({
  amountInDollars,
  description,
  disableInteractions,
  discountedPriceInDollars,
  iconProps,
  itemType,
  longDescription,
  modalProps,
  tooltipProps,
  desktopTooltipProps
}) {
  const amountWithCurrencySign = ensureCurrencyIsPresent(amountInDollars);
  const showIcon = iconProps != null && !disableInteractions;

  return (
    <>
      <div className="StripeChargeModalPaymentSummaryLineItem f2 f3-md flex ph4 pv4">
        <div className="flex-auto">
          <div className="inline-flex items-center">
            <span className="pr2 f2 f3-md">{description}</span>
            {showIcon && (
              <StripeChargeModalIconRenderWrapper
                iconProps={iconProps}
                tooltipProps={tooltipProps}
                modalProps={modalProps}
                desktopTooltipProps={desktopTooltipProps}
              />
            )}
          </div>
          <p className="StripeChargeModalPaymentSummaryLineItem__description f2 black o-60">
            {longDescription}
          </p>
        </div>
        <p>
          {discountedPriceInDollars !== null && (
            <>
              <span className="strike gray">
                {ensureCurrencyIsPresent(discountedPriceInDollars)}
              </span>
              &nbsp;&nbsp;
            </>
          )}
          <span
            className="StripeChargeModalPaymentSummaryLineItem__amount"
            data-test-id={`StripeChargeModalPaymentSummaryLineItem-${itemType}-amount`}
          >
            {amountWithCurrencySign}
          </span>
        </p>
      </div>
    </>
  );
}

StripeChargeModalPaymentSummaryLineItemV2.propTypes = {
  amountInDollars: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  longDescription: PropTypes.string,
  discountedPriceInDollars: PropTypes.string,
  iconProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
    renderFunction: PropTypes.func,
    buttonId: PropTypes.string
  }),
  itemType: PropTypes.string.isRequired,
  tooltipProps: PropTypes.shape({
    title: PropTypes.node.isRequired,
    className: PropTypes.string,
    minWidth: PropTypes.string,
    isVisible: PropTypes.bool
  }),
  disableInteractions: PropTypes.bool,
  modalProps: PropTypes.shape({
    maxWidth: PropTypes.string,
    content: PropTypes.node.isRequired,
    isVisible: PropTypes.bool,
    onVisibilityChanged: PropTypes.func
  }),
  desktopTooltipProps: PropTypes.shape({
    title: PropTypes.node.isRequired
  })
};

StripeChargeModalPaymentSummaryLineItemV2.defaultProps = {
  longDescription: null,
  discountedPriceInDollars: null,
  iconProps: null,
  tooltipProps: null,
  disableInteractions: false,
  modalProps: null,
  desktopTooltipProps: null
};
